import { CometChatAuthTokenResponse } from "../../models/dtos/CometChatAuthTokenResponse";
import { api } from "./api";


export const cometchatApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAuthToken: build.mutation<CometChatAuthTokenResponse, string>({
            query: (uid) => ({
                url: `bo/messaging/auth-token/${uid}`,
                method: 'POST',
            }),
        }),
    }),
});
export const { useGetAuthTokenMutation } = cometchatApi;